import './polyfill'
// import cssVars from 'css-vars-ponyfill'
import BootstrapVue from 'bootstrap-vue'

import Vue from 'vue'
import App from './app'
import router from '@router'
import store from '@state/store'
import '@components/_globals'
import A11yDialog from 'vue-a11y-dialog'
import 'vue-good-table/dist/vue-good-table.css'
import VueNumerals from 'vue-numerals'
import 'vue-search-select/dist/VueSearchSelect.css'
import 'vue-loaders/dist/vue-loaders.css'
import VueLoaders from 'vue-loaders'
import VueKonva from 'vue-konva'
import VueHtmlToPaper from 'vue-html-to-paper'
import IdleVue from 'idle-vue'

import VueAWN from 'vue-awesome-notifications'
import Print from 'vue-print-plugin'
//import clipper from 'vuejs-clipper'
import Vuerx from 'vue-rx'
Vue.use(Vuerx)

// Vue.use(clipper)
// import './design/darcula.css'

Vue.config.productionTip = false
Vue.config.silent = true

// include the default style

// Tell Vue to install the plugin.
const eventsHub = new Vue()
Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  store,
  idleTime: 3600000, // 3600 seconds / 1 hour
  startAtIdle: false,
})
Vue.use(VueAWN, VueHtmlToPaper, Print)

Vue.use(VueKonva)

Vue.use(VueLoaders)

Vue.use(VueNumerals, {
  locale: 'en',
})
// Don't warn about using the dev version of Vue in development
Vue.config.productionTip = process.env.NODE_ENV === 'production'

Vue.use(BootstrapVue)
Vue.use(A11yDialog)
const app = new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')

// If running inside Cypress
if (window.Cypress) {
  // Attach the app to the window, which can be useful
  // for manually setting state in Cypress commands
  // such as `cy.logIn()`
  window.__app__ = app
}
